(function () {
    var cookieName = 'kvadre_promo_banner_closed';
    var cookiePattern = new RegExp('(?:^|;\\s*)' + cookieName + '=1(?:;|$)');

    function isClosed() {
        return cookiePattern.test(document.cookie);
    }

    function findBanner(element) {
        return element && element.closest
            ? element.closest('[data-promo-banner]')
            : null;
    }

    function removeClosedBanner() {
        if (!isClosed()) return;

        var banner = document.querySelector('[data-promo-banner]');
        if (banner) banner.remove();
    }

    removeClosedBanner();

    document.addEventListener('DOMContentLoaded', removeClosedBanner);

    document.addEventListener('click', function (event) {
        var closeButton = event.target.closest('[data-promo-banner-close]');
        if (!closeButton) return;

        var banner = findBanner(closeButton);
        if (!banner) return;

        event.preventDefault();
        event.stopPropagation();

        var cookie = cookieName + '=1; path=/; max-age=31536000; samesite=lax';
        if (window.location.protocol === 'https:') {
            cookie += '; secure';
        }

        document.cookie = cookie;
        banner.remove();
    });
})();
